<template>
    <div>
        <image-button
                @click.native="showModal = true"
                img="/images/svg/ATS3bdSeriesicon_Agg.svg"
        >
            aggregate time series
        </image-button>

        <portal to="modals" v-if="showModal">
            <modal-bottom v-if="showModal" @close="close()" class="bg-grey-lighter">
                <h3 slot="header">Aggregations</h3>

                <div slot="save" v-show="action !== null">
                    <a class="cursor-pointer inline-block bg-blue text-white px-4 py-2 rounded" v-show="true"
                       @click="save()">
                        Apply
                    </a>
                </div>

                <!--
                <p class="text-grey-dark text-sm">Calculate the total or the average value for all time
                                    series:<br>
                                    sum = series1 + ... + seriesN<br>
                                    average = sum / N
                                </p>
                -->

                <button class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                        @click="action = 'sum'">Sum
                </button>
                <button class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                        @click="action = 'avg'">Average
                </button>

                <button class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                        @click="action = 'min'">Min
                </button>

                <button class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                        @click="action = 'max'">Max
                </button>

            </modal-bottom>
        </portal>

    </div>
</template>

<script>

    import ImageButton from "../ImageButton";
    import ModalBottom from "../ModalBottom";
    import CustomSeries from "../../modifiers/CustomSeries";

    export default {
        name: "ComputeAggregation",

        components: {ModalBottom, ImageButton},

        data: () => ({
            showModal: false,
            action: null,
        }),

        computed: {
            selected() {
                return this.$store.state.rawData.data[this.$store.state.periodicity].data.map(function (item, index) {
                    return index;
                });
            },
            series() {
                // TODO filter by ids... LOL
                return this.$store.getters.compute;
            },
        },

        watch: {
            action() {
                this.modify();
            },
            steps() {
                this.modify();
            },
            span() {
                this.modify();
            },
            showModal() {
                this.action = null;
            },
        },

        methods: {
            close() {
                this.$store.dispatch('abort');
                this.showModal = false;
            },
            modify() {
                if (this.action === null) {
                    return this.$store.dispatch('abort');
                }

                let series = new CustomSeries();

                if (this.action === 'sum') {
                    series.sum(this.series);
                }
                if (this.action === 'avg') {
                    series.avg(this.series);
                }
                if (this.action === 'min') {
                    series.min(this.series);
                }
                if (this.action === 'max') {
                    series.max(this.series);
                }

                this.$store.dispatch('tempSeries', [series.object()]);
            },
            save() {
                this.$store.dispatch('save');
                this.showModal = false;
            }
        }
    }
</script>

<style scoped>

</style>
